import {Card} from "../../../../../components/card/card.jsx";
import OnlineUsersCard from "./online-users-card.jsx";
import AnalyticsCard from "./analytics-card.jsx";
import PassageSearchCard from "./passage-search-card.jsx";
import DashCard from "../../../../../components/dash-card/dash-card.jsx";

export default function UsersCard({ usersData }) {
    return (
        <section className="col-span-3 flex min-h-0 min-w-0 flex-col">
            <Card.Header className="border-b-0! bg-transparent! shrink-0">
                <Card.Title className="bg-transparent text-[#F4FFFF] text-center w-full text-(length:--font-lg)!">
                    Usuários
                </Card.Title>
            </Card.Header>
            <Card.Body className="flex-1 min-h-0 min-w-0 flex pl-(--dash-pad-md)! pr-0! pb-(--dash-pad-md)!">
                <DashCard width="100%" height="100%" className="h-full min-h-0 min-w-0">
                    <section className="h-full min-h-0 min-w-0 grid grid-cols-2 grid-rows-[minmax(0,2fr)_minmax(0,3fr)] gap-(--dash-pad-md)">
                        <OnlineUsersCard onlineUsers={usersData} />

                        <PassageSearchCard passageSearch={usersData} />

                        <AnalyticsCard usersAnalytics={usersData} />
                    </section>
                </DashCard>
            </Card.Body>
        </section>
    )
}
